module.exports = __webpack_public_path__ + "static/Curbside-Pick-Up-918c3fccecbf9f4d64f2b79060fe8f1b.jpg";